import { useTranslation } from "react-i18next";

interface IntegrationScopeFieldProps {
  isGlobal: boolean;
  onChange: (isGlobal: boolean) => void;
  /** `name` do grupo de radios — dois formulários na mesma tela não podem dividir o grupo. */
  name?: string;
  disabled?: boolean;
  /** Sem o traço e o espaço de cima — quando o campo abre a seção, e não fecha um formulário. */
  bare?: boolean;
}

/**
 * Escopo da instalação: Workspace (`local`, vinculada ao produto atual) ou Organização
 * (`global`). Quem decide se o campo aparece é o chamador — na Visão da organização e na
 * plataforma não há produto, e o escopo é sempre global.
 */
export const IntegrationScopeField = ({
  isGlobal,
  onChange,
  name = "integration-scope",
  disabled,
  bare,
}: IntegrationScopeFieldProps) => {
  const { t } = useTranslation();
  return (
    <div className={bare ? "space-y-3" : "space-y-3 pt-2 border-t"}>
      <h3 className="text-sm font-semibold text-muted-foreground">{t('integrations.scope.permissionsLabel')}</h3>
      <div className="space-y-2">
        <label className="flex items-center gap-2 cursor-pointer">
          <input
            type="radio"
            name={name}
            checked={!isGlobal}
            disabled={disabled}
            onChange={() => onChange(false)}
            className="h-4 w-4 text-primary focus:ring-primary border-gray-300"
          />
          <span className="text-sm font-medium">{t('integrations.scope.productLabel')}</span>
        </label>
        <label className="flex items-center gap-2 cursor-pointer">
          <input
            type="radio"
            name={name}
            checked={isGlobal}
            disabled={disabled}
            onChange={() => onChange(true)}
            className="h-4 w-4 text-primary focus:ring-primary border-gray-300"
          />
          <span className="text-sm font-medium">{t('integrations.scope.organizationLabel')}</span>
        </label>
      </div>
      <p className="text-xs text-muted-foreground">
        {isGlobal
          ? t('integrations.scope.organizationHint')
          : t('integrations.scope.productHint')}
      </p>
    </div>
  );
};
